/*
 * @Author: wyq
 * @Date: 2021-07-27 15:53:46
 * @LastEditTime: 2021-09-07 15:35:07
 * @LastEditors: wyq
 * @Description: 
 * @FilePath: \question_bank_console\src\utils\dialogMixin.js
 */
export default {
  props: {
    visible: Boolean,
    grade: Number,
    subject: Number,
  },
  data() {
    return {
      dialogVisible: false,
      submitLoadding: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        console.log('visible', val)
        if (val != this.dialogVisible) {
          this.dialogVisible = val
          this.submitLoadding = false
        }
      },
      immediate: true,
    },
    dialogVisible(val) {
      if (val != this.visible) {
        this.$emit('update:visible', val)
      }
    },
  },
  methods: {
    submit() {
      this.submitLoadding = true
      this.dialogVisible = false
      this.$emit('submit')
    },
    close() {
      this.dialogVisible = false
    },
  },
}